export default __webpack_public_path__ + "static/media/CS-Raceweek-Canada(330x330).9864da5b.webp";